import {
  AllocationViewActionRequestSlotModel,
  AllocationViewActionRequestUliModel,
} from '../allocation-view-action-request.model';
import { AllocationViewUliInfoItemModel } from '../allocation-register-uli-details';
import { TruckModel } from '../TruckModel';

export class CallToDockPrepareModel {
  hasInboundUlis: boolean;
  calendarOverbookingCheckPassed: boolean;
  callToDockTimestamp: number;
  dockOverbookingCheckPassed: boolean;
  hubId: number;
  truck: TruckModel;
  slot: AllocationViewActionRequestSlotModel;
  truckUlis: AllocationViewUliInfoItemModel[];

  constructor(params?: CallToDockPrepareModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationActionPrepareCallToDockModel extends CallToDockPrepareModel {
  activeSlots: Array<AllocationViewUliInfoItemModel[]>;
  inactiveSlots: Array<AllocationViewUliInfoItemModel[]>;

  constructor(params?: CallToDockPrepareModel) {
    super(params);

    this.activeSlots = [...this.groupUliSlots(params.truckUlis)].filter((items: AllocationViewUliInfoItemModel[]) =>
      items.some((item: AllocationViewUliInfoItemModel) => item.selected),
    );
    this.inactiveSlots = [...this.groupUliSlots(params.truckUlis)].filter((items: AllocationViewUliInfoItemModel[]) =>
      items.every((item: AllocationViewUliInfoItemModel) => !item.selected),
    );
  }

  private groupUliSlots(ulis: AllocationViewUliInfoItemModel[]): Array<AllocationViewUliInfoItemModel[]> {
    const ulisMap = ulis.reduce(
      (entryMap: Map<string, AllocationViewUliInfoItemModel[]>, currentUli: AllocationViewUliInfoItemModel) => {
        const slotId: string = currentUli.allocationSlot?.slotId;
        return entryMap.set(slotId, [...(entryMap.get(slotId) || []), currentUli]);
      },
      new Map(),
    );

    return Array.from(ulisMap.values());
  }
}

export class CallToDockRequestModel {
  hubId: number;
  callToDockTimestamp: number;
  slot: AllocationViewActionRequestSlotModel;
  ulis: AllocationViewActionRequestUliModel[];
  truckId?: number;

  constructor(params?: CallToDockPrepareModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
